import PageScrollHandler from 'utils/PageScrollHandler';


const elements = document.querySelectorAll('[data-scroll-anim]');

Array.forEach(elements, (element) => {
  const animatedClass = element.getAttribute('data-scroll-anim');

  if (animatedClass !== null || animatedClass !== '' || animatedClass !== undefined) {
    PageScrollHandler.registerNewElement(element, () => {
      element.classList.add(animatedClass);
    }, false);
  }
});
